import Web3 from 'web3';
import { ethers } from 'ethers'
import axios from "axios";


const tokenURIPrefix = gon.tokenURIPrefix;
const transferProxyContractAddress = gon.transferProxyContractAddress;
const tokenAddress = gon.tokenAddress;
const tradeContractAddress = gon.tradeContractAddress;
const factoryContractAddressFor721 = gon.factoryContractAddressFor721
const factoryContractAddressFor1155 = gon.factoryContractAddressFor1155
let account;

let signer;
let provider;

async function loadWeb3() {
  if (!window.ethereum) {
    return;
  }

  window.web3 = new Web3(window.ethereum);

  if (window.ethereum.request) {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
  } else if (typeof window.ethereum.enable === 'function') {
    await window.ethereum.enable();
  }

  provider = new ethers.providers.Web3Provider(window.ethereum);
  signer = provider.getSigner();
  gon.provider = provider;
}

function nativeCurrencyForChain(chainId) {
  switch (parseInt(chainId, 10)) {
    case 56:
      return { name: 'BNB', symbol: 'BNB', decimals: 18 };
    case 137:
      return { name: 'POL', symbol: 'POL', decimals: 18 };
    default:
      return { name: 'Ether', symbol: 'ETH', decimals: 18 };
  }
}

function networkAddParams(chainId) {
  const chainIdNum = parseInt(chainId, 10);
  const hexChainId = '0x' + chainIdNum.toString(16);
  const networks = gon.networks || [];
  const network = networks.find((n) => parseInt(n.chainId, 10) === chainIdNum);

  if (network && network.rpcUrl) {
    const params = {
      chainId: hexChainId,
      chainName: network.chainName || 'Network',
      nativeCurrency: nativeCurrencyForChain(chainIdNum),
      rpcUrls: [network.rpcUrl]
    };
    if (network.explorerUrl) {
      params.blockExplorerUrls = [network.explorerUrl];
    }
    return params;
  }

  const fallback = {
    1: {
      chainName: 'Ethereum Mainnet',
      rpcUrls: ['https://cloudflare-eth.com'],
      blockExplorerUrls: ['https://etherscan.io']
    },
    56: {
      chainName: 'BNB Smart Chain',
      rpcUrls: ['https://bsc-dataseed.binance.org/'],
      blockExplorerUrls: ['https://bscscan.com']
    },
    137: {
      chainName: 'Polygon Mainnet',
      rpcUrls: ['https://polygon-rpc.com'],
      blockExplorerUrls: ['https://polygonscan.com']
    }
  }[chainIdNum];

  if (!fallback) {
    return null;
  }

  return {
    chainId: hexChainId,
    chainName: fallback.chainName,
    nativeCurrency: nativeCurrencyForChain(chainIdNum),
    rpcUrls: fallback.rpcUrls,
    blockExplorerUrls: fallback.blockExplorerUrls
  };
}

window.switchToNetwork = async function switchToNetwork(chainId) {
  if (!window.ethereum) {
    throw new Error('MetaMask is not installed');
  }

  const chainIdNum = parseInt(chainId, 10);
  const hexChainId = '0x' + chainIdNum.toString(16);

  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: hexChainId }]
    });
  } catch (switchError) {
    if (switchError.code === 4902) {
      const params = networkAddParams(chainIdNum);
      if (!params) {
        throw switchError;
      }
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [params]
      });
    } else {
      throw switchError;
    }
  }

  await loadWeb3();
  return true;
}

function parseMetaMaskChainId(chainId) {
  if (chainId === undefined || chainId === null || chainId === '') {
    return null;
  }
  if (typeof chainId === 'string' && chainId.startsWith('0x')) {
    return parseInt(chainId, 16);
  }
  const parsed = parseInt(chainId, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

function getCurrentSiteChainId() {
  if (typeof window.getCookie === 'function') {
    const fromCookie = parseInt(window.getCookie('chain_id'), 10);
    if (!Number.isNaN(fromCookie) && fromCookie > 0) {
      return fromCookie;
    }
  }
  return parseInt(gon.chain_id, 10);
}

window.syncSiteNetworkFromMetaMask = async function syncSiteNetworkFromMetaMask(chainId) {
  const chainIdNum = parseMetaMaskChainId(chainId);
  if (!chainIdNum) {
    return;
  }

  const networks = gon.networks || [];
  const supported = networks.some((n) => parseInt(n.chainId, 10) === chainIdNum);
  const currentChainId = getCurrentSiteChainId();

  if (!supported) {
    $('.loading-gif-network').show();
    return;
  }

  $('.loading-gif-network').hide();

  if (chainIdNum === currentChainId) {
    await loadWeb3();
    if (typeof window.updateEthBalance === 'function') {
      window.updateEthBalance();
    }
    return;
  }

  if (window.__siteNetworkSwitchInProgress) {
    return;
  }

  window.__syncingSiteFromMetaMask = true;
  window.location.href = `/change_network/?chain_id=${chainIdNum}`;
}

async function getaccounts() {
  try {
    const signer = provider.getSigner();
    const accounts = await signer.getAddress();
    return accounts;
  } catch (e) {
   }
 }

async function createUserSession(address, balance, destroySession) {
  const config = {
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }
  const resp = await axios.post(`/sessions`, {
    address: address,
    balance: balance,
    destroy_session: destroySession
  }, config)
    .then((response) => {
      return resp
    })
    .catch(err => {
    })
  return resp;
}

async function destroyUserSession(address) {
  const config = {
    data: {},
    headers: {
      'X-CSRF-TOKEN': $('[name="csrf-token"]')[0].content,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }
  const resp = axios.delete(`/sessions/${address}`, config)
    .then(response => response)
    .catch(err => {})
  return resp
}

function updateTokenId(tokenId, collectionId, txId) {
  var request = $.ajax({
    url: `/collections/${collectionId}/update_token_id`,
    async: false,
    type: "POST",
    data: {tokenId: tokenId, collectionId: collectionId, tx_id: txId},
    dataType: "script"
  });
  request.done(function (msg) {
  });
  request.fail(function (jqXHR, textStatus) {
  });
}

function saveContractNonceValue(collectionId, sign) {
  var request = $.ajax({
    url: `/collections/${collectionId}/save_contract_nonce_value`,
    async: false,
    type: "POST",
    data: {signature : sign},
    dataType: "script"
  });
  request.done(function (msg) {
  });
  request.fail(function (jqXHR, textStatus) {
  });
}

function createContract(formData) {
  var request = $.ajax({
    url: '/users/create_contract',
    async: false,
    type: "POST",
    data: formData,
    dataType: "script",
    processData: false,
    contentType: false,
    cache: false,
  });
  request.done(function (msg) {
  });
  request.fail(function (jqXHR, textStatus) {
  });
}

function updateCollectionBuy(collectionId, quantity, transactionHash) {
  var request = $.ajax({
    url: '/collections/' + collectionId + '/buy',
    type: 'POST',
    async: false,
    data: {quantity: quantity, transaction_hash: transactionHash},
    dataType: "script",
    success: function (respVal) {
    }
  });
}

function updateCollectionSell(collectionId, buyerAddress, bidId, transactionHash) {
  var request = $.ajax({
    url: '/collections/' + collectionId + '/sell',
    type: 'POST',
    async: false,
    data: {address: buyerAddress, bid_id: bidId, transaction_hash: transactionHash},
    dataType: "script",
    success: function (respVal) {
    }
  });
}

function updateOwnerTransfer(collectionId, recipientAddress, transactionHash, supply) {
  var request = $.ajax({
    url: '/collections/' + collectionId + '/owner_transfer',
    type: 'POST',
    async: false,
    data: {recipient_address: recipientAddress, transaction_hash: transactionHash, supply: supply},
    dataType: "script",
    success: function (respVal) {
    }
  });
}

function updateBurn(collectionId, transactionHash, supply) {
  var request = $.ajax({
    url: '/collections/' + collectionId + '/burn',
    type: 'POST',
    async: false,
    data: {transaction_hash: transactionHash, supply: supply},
    dataType: "script",
    success: function (respVal) {
    }
  });
}

async function isValidUser(address, token) {
  const config = {
    headers: {
      'X-CSRF-TOKEN': token,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }
  const resp = await axios.get(`/sessions/valid_user`, {params: {address: address, authenticity_token: token}}, config)
    .then((response) => {
      return response.data
    })
    .catch(err => {
    })
  return resp;
}

function placeBid(collectionId, sign, quantity, bidDetails) {
  var request = $.ajax({
    url: `/collections/${collectionId}/bid`,
    type: "POST",
    async: false,
    data: {sign: sign, quantity: quantity, details: bidDetails},
    dataType: "script"
  });
  request.done(function (msg) {
  });
  request.fail(function (jqXHR, textStatus) {
  });
}

function signMetadataHash(collectionId, contractAddress) {
  var sign;
  var request = $.ajax({
    url: `/collections/${collectionId}/sign_metadata_hash`,
    type: "POST",
    async: false,
    data: {contract_address: contractAddress},
    dataType: "json"
  });
  request.done(function (msg) {
    sign = {sign: msg['signature'], nonce: msg['nonce']}
  });
  request.fail(function (jqXHR, textStatus) {
  });
  return sign;
}

function updateSignature(collectionId, sign) {
  var request = $.ajax({
    url: `/collections/${collectionId}/sign_fixed_price`,
    type: "POST",
    async: false,
    data: {sign: sign},
    dataType: "script"
  });
  request.done(function (msg) {
  });
  request.fail(function (jqXHR, textStatus) {
  });
}

function getNonceValue(collectionId) {
  var nonce;
  var request = $.ajax({
    url: `/collections/${collectionId}/get_nonce_value`,
    type: "POST",
    async: false,
    data: {},
    dataType: "json"
  });
  request.done(function (data) {
    nonce = data['nonce']
  });
  request.fail(function (jqXHR, textStatus) {
  });
  return nonce
}

function save_NonceValue(collectionId, sign, nonce) {
  var request = $.ajax({
    url: `/collections/${collectionId}/save_nonce_value`,
    type: "POST",
    async: false,
    data: {sign: sign, nonce: nonce},
    dataType: "script"
  });
  request.done(function (msg) {
  });
  request.fail(function (jqXHR, textStatus) {
  });
}

function getContractSignNonce(collectionId, sign) {
  var nonce;
  var request = $.ajax({
    url: `/collections/${collectionId}/get_contract_sign_nonce`,
    type: "POST",
    async: false,
    data: {sign: sign},
    dataType: "json"
  });
  request.done(function (data) {
    nonce = data['nonce']
  });
  request.fail(function (jqXHR, textStatus) {
  });
  return nonce
}



window.getContractABIAndBytecode = function getContractABIAndBytecode(contractAddress, type, shared = true) {
  var res;
  var request = $.ajax({
    async: false,
    url: '/contract_abi',
    type: "GET",
    data: {contract_address: contractAddress, type: type, shared: shared},
    dataType: "json"
  });

  request.done(function (msg) {
    res = msg;
  });

  request.fail(function (jqXHR, textStatus) {
  });
  return res;
}

function splitSign(sign, nonce) {
  let sig = ethers.utils.splitSignature(sign);
  return [sig.v,sig.r,sig.s, nonce];
}

window.getContract = async function getContract(contractAddress, type, shared = true) {
  var res = getContractABIAndBytecode(contractAddress, type, shared);
  var contractObj = new ethers.Contract(contractAddress, res['compiled_contract_details']['abi'], provider);
  return contractObj
}

window.createCollectible721 = async function createCollectible721(contractAddress, tokenURI, royaltyFee, collectionId, sharedCollection) {
  try {
    var account = await getaccounts();
    let contract721 = await getContract(contractAddress, 'nft721', sharedCollection);
    let contract721WithSigner = contract721.connect(signer);
    window.contract721 = contract721WithSigner;
    var gasPrices = await gasPrice();
    royaltyFee = royaltyFee ? royaltyFee : 0;
    var txn;
    if (sharedCollection) {
      var sign = await signMetadataHash(collectionId, contractAddress);
      await saveContractNonceValue(collectionId, sign);
      var signStruct = splitSign(sign['sign'], sign['nonce']);
      txn = await window.contract721.mint(tokenURI, royaltyFee, signStruct, {
        from: account,
        gasPrice: String(gasPrices)
      });
    } else {
      txn = await window.contract721.mint(tokenURI, royaltyFee, {
        from: account,
        gasPrice: String(gasPrices)
      });
    }
    txn = await txn.wait();
    var tokenId = mintedTokenId(txn);
    if (!tokenId) {
      throw new Error('Minted token id not found in transaction receipt');
    }
    await updateTokenId(tokenId, collectionId, txn.transactionHash)
    return window.collectionMintSuccess(collectionId)
  } catch (err) {
    return window.collectionMintFailed(err['message'])
  }
}

window.createCollectible1155 = async function createCollectible1155(contractAddress, supply, tokenURI, royaltyFee, collectionId, sharedCollection) {
  try {
    var account = await getaccounts();
    let contract1155 = await getContract(contractAddress, 'nft1155', sharedCollection);
    let contract1155WithSigner = contract1155.connect(signer);
    window.contract1155 = contract1155WithSigner;
    var gasPrices = await gasPrice();
    var txn;
    if (sharedCollection) {
      var sign = await signMetadataHash(collectionId, contractAddress);
      await saveContractNonceValue(collectionId, sign)
      var signStruct = splitSign(sign['sign'], sign['nonce']);
      txn = await window.contract1155.mint(tokenURI, royaltyFee, supply, signStruct,{
        from: account,
        gasPrice: String(gasPrices)
      });
    } else {
      txn = await window.contract1155.mint(tokenURI, royaltyFee, supply,{
        from: account,
        gasPrice: String(gasPrices)
      });
    }
    var tx = await txn.wait();
    var tokenId = mintedTokenId(tx);
    if (!tokenId) {
      throw new Error('Minted token id not found in transaction receipt');
    }
    await updateTokenId(tokenId, collectionId, tx.transactionHash)
    return window.collectionMintSuccess(collectionId)
  } catch (err) {
    return window.collectionMintFailed(err['message'])
  }
}

function getRandom(address) {
  let value = Date.now() + Math.floor((Math.random() * (10 ** 10)) + 1);
  var hex = value.toString(16);
  hex = hex + address.slice(2);
  return `0x${'0'.repeat(64-hex.length)}${hex}`;
}

const deployedEventTopic = ethers.utils.id('Deployed(address,address)');

function addressFromDeployedLogData(data) {
  if (!data || data.length < 130) {
    return null;
  }
  return ethers.utils.getAddress('0x' + data.slice(66, 130));
}

function deployedContractAddress(receipt, factoryAbi, factoryAddress) {
  if (receipt.events && receipt.events.length) {
    for (var i = 0; i < receipt.events.length; i++) {
      var event = receipt.events[i];
      if (event.args && event.args.contractAddress) {
        return event.args.contractAddress;
      }
      if (event.args && event.args.addr) {
        return event.args.addr;
      }
    }
  }
  if (receipt.logs && receipt.logs.length) {
    var factoryIface = factoryAbi ? new ethers.utils.Interface(factoryAbi) : null;
    var factoryAddressLower = factoryAddress ? factoryAddress.toLowerCase() : null;
    for (var j = 0; j < receipt.logs.length; j++) {
      var log = receipt.logs[j];
      if (factoryAddressLower && log.address && log.address.toLowerCase() !== factoryAddressLower) {
        continue;
      }
      if (log.topics && log.topics[0] === deployedEventTopic) {
        var addressFromData = addressFromDeployedLogData(log.data);
        if (addressFromData) {
          return addressFromData;
        }
      }
      if (!factoryIface) {
        continue;
      }
      try {
        var parsed = factoryIface.parseLog(log);
        if (parsed.name === 'Deployed' && parsed.args.contractAddress) {
          return parsed.args.contractAddress;
        }
      } catch (e) {}
    }
  }
  if (receipt.contractAddress) {
    return receipt.contractAddress;
  }
  return null;
}

function mintedTokenId(receipt) {
  if (receipt.events && receipt.events.length) {
    for (var i = 0; i < receipt.events.length; i++) {
      var event = receipt.events[i];
      if (event.args && event.args.tokenId != null) {
        return event.args.tokenId.toString();
      }
      if (event.args && event.args.id != null) {
        return event.args.id.toString();
      }
    }
  }
  if (receipt.logs && receipt.logs.length) {
    for (var j = 0; j < receipt.logs.length; j++) {
      var log = receipt.logs[j];
      if (log.topics && log.topics.length >= 4) {
        return parseInt(log.topics[3], 16).toString();
      }
    }
  }
  return null;
}

window.deployContract = async function deployContract(abi, bytecode, name, symbol, contractType, collectionId, attachment, description, cover) {
  var contractAddress;
  var account =  await getaccounts();
  var salt = getRandom(account);
  var contractDeploy;
  try {
    var factoryAddress;
    if (contractType == 'nft721') {
      factoryAddress = factoryContractAddressFor721;
      contractDeploy = await new ethers.Contract(factoryAddress, abi, provider);
    } else if(contractType == 'nft1155') {
      factoryAddress = factoryContractAddressFor1155;
      contractDeploy = await new ethers.Contract(factoryAddress, abi, provider);
    }
    const contract = contractDeploy.connect(signer);
    var predictedAddress = await contract.callStatic.deploy(salt, name, symbol, tokenURIPrefix, {from: account});
    let tx = await contract.deploy(salt, name, symbol, tokenURIPrefix);
    var receipt = await tx.wait();
    contractAddress = deployedContractAddress(receipt, abi, factoryAddress) || predictedAddress;
    if (!contractAddress) {
      throw new Error('Deployed contract address not found in transaction receipt');
    }
    $('#nft_contract_address').val(contractAddress);
    let formData = new FormData()
    formData.append('file', attachment)
    formData.append('name', name)
    formData.append('symbol', symbol)
    formData.append('contract_address', contractAddress)
    formData.append('contract_type', contractType)
    formData.append('collection_id', collectionId)
    formData.append('description', description)
    formData.append('cover', cover)
    createContract(formData);
    window.contractDeploySuccess(contractAddress, contractType)
  } catch (err){
    window.contractDeployFailed(err['message'])
  };
}

window.approveNFT = async function approveNFT(contractType, contractAddress, sharedCollection, sendBackTo = 'collection') {
  try {
    $(".modal-backdrop.show").remove();
    var account = await getaccounts();
    var contractCode = await provider.getCode(contractAddress);
    if (!contractCode || contractCode === '0x') {
      throw new Error('NFT contract not found on this network: ' + contractAddress);
    }
    let contractNFT = await getContract(contractAddress, contractType, sharedCollection);
    const contract = contractNFT.connect(signer);
    window.contract = contract;
    var isApproved = await window.contract.isApprovedForAll(account, transferProxyContractAddress);   if (!isApproved) {
      var receipt = await window.contract.setApprovalForAll(transferProxyContractAddress, true, {from: account});
      receipt = await receipt.wait()
    }
    if (sendBackTo == 'executeBid') {
      return window.approveBidSuccess()
    } else {
      return window.collectionApproveSuccess(contractType);
    }
  } catch (err) {
    if (sendBackTo == 'executeBid') {
      return window.approveBidFailed(err['message'])
    } else {
      return window.collectionApproveFailed(err['message'])
    }
  }
}

window.approveResaleNFT = async function approveResaleNFT(contractType, contractAddress, sharedCollection) {
  try {
    var account = await getaccounts();
    let contractNFT = await getContract(contractAddress, contractType, sharedCollection);
    const contract = contractNFT.connect(signer);
    var isApproved = await contract.isApprovedForAll(account, transferProxyContractAddress);
    if (!isApproved) {
      var receipt = await contract.setApprovalForAll(transferProxyContractAddress, true, {from: account});
    }
    return window.approveResaleSuccess(contractType);
  } catch (err) {
    return window.approveResaleFailed(err['message'])
  }
}

//TODO: OPTIMIZE
window.isApprovedNFT = async function isApprovedNFT(contractType, contractAddress) {
  try {
    var contract = await getContract(contractAddress, contractType);
    var account = window.ethereum.selectedAddress
    var isApproved = await contract.methods.isApprovedForAll(account, transferProxyContractAddress).call();
    return isApproved;
  } catch (err) {
  }
}

window.burnNFT = async function burnNFT(contractType, contractAddress, tokenId, supply = 1, collectionId, sharedCollection) {
  try {
    var contractNFT = await getContract(contractAddress, contractType, sharedCollection);
    const contract = contractNFT.connect(signer);
    var account = await getaccounts();
    if (contractType == 'nft721') {
      var receipt = await contract.burn(tokenId, {from: account});
    } else if (contractType == 'nft1155') {
      var receipt = await contract.burn(account, tokenId, supply, {from: account});
    }
    receipt = await receipt.wait();
    await updateBurn(collectionId, receipt.transactionHash, supply)
    return window.burnSuccess(receipt.transactionHash);
  } catch (err) {
    return window.burnFailed(err['message'])
  }
}

window.directTransferNFT = async function directTransferNFT(contractType, contractAddress, recipientAddress, tokenId, supply = 1, shared, collectionId) {
  try {
    var contractNFT = await getContract(contractAddress, contractType, shared);//for all direct transfer it should interact with trade contract
    const contract = contractNFT.connect(signer);
    var account = await getaccounts();
    if (contractType == 'nft721') {
      var receipt = await contract["safeTransferFrom(address,address,uint256)"](account, recipientAddress, tokenId, {from: account});
    } else if (contractType == 'nft1155') {
      // TODO: Analyse and use proper one in future
      var tempData = "0x6d6168616d000000000000000000000000000000000000000000000000000000"
      var receipt = await contract["safeTransferFrom(address,address,uint256,uint256,bytes)"](account, recipientAddress, tokenId, supply, tempData, {from: account});
    }
    receipt = await receipt.wait();
    await updateOwnerTransfer(collectionId, recipientAddress, receipt.transactionHash, supply)
    return window.directTransferSuccess(receipt.transactionHash, collectionId);
  } catch (err) {
    return window.directTransferFailed(err['message']);
  }
}

window.approveERC20 = async function approveERC20(contractAddress, contractType, amount, decimals = 18, sendBackTo = 'Bid') {
  try {
    amount = roundNumber(mulBy(amount, 10 ** decimals), 0);
    var compiledContractDetails = getContractABIAndBytecode(contractAddress, contractType, gon.collection_data['contract_shared']);
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
 var contractNFT = await getContract(contractAddress, contractType);
    const contract = contractNFT.connect(signer);

    var account = await getaccounts();
    var balance = await contract.allowance(account, transferProxyContractAddress);
    amount = BigInt(parseInt(balance) + parseInt(amount)).toString();
    var receipt = await contract.approve(transferProxyContractAddress, amount, {from: account});
    receipt = await receipt.wait();
    if (sendBackTo == 'Buy') {
      return window.buyApproveSuccess(receipt.transactionHash, contractAddress)
    } else {
      return window.bidApproveSuccess(receipt.transactionHash, contractAddress)
    }
  } catch (err) {
    if (sendBackTo == 'Buy') {
      return window.buyApproveFailed(err['message'])
    } else {
      return window.bidApproveFailed(err['message'])
    }
  }
}

window.approvedTokenBalance = async function approvedTokenBalance(contractAddress) {
  var contract = await getContract(contractAddress, 'erc20', false);
  var account = window.ethereum.selectedAddress
  var balance = await contract.allowance(account, transferProxyContractAddress);
  return balance;
}

window.convertToken = async function convertToken(amount, sendBackTo = 'Bid', decimals = 18) {
  try {
    amount = roundNumber(mulBy(amount, 10 ** decimals), 0);
    var compiledContractDetails = getContractABIAndBytecode(tokenAddress, 'erc20');
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
    var contract = await new window.web3.eth.Contract(abi, tokenAddress);
    var account = window.ethereum.selectedAddress
    var balance = await contract.methods.allowance(account, transferProxyContractAddress).call();
    amount = BigInt(parseInt(balance) + parseInt(amount)).toString()
    var gasPrices = await gasPrice();
    var receipt = await contract.methods.deposit().send({from: account, value: amount,gas: 316883,gasPrice: String(gasPrices)});
    if (sendBackTo == 'Buy') {
      return window.buyConvertSuccess(receipt.transactionHash)
    } else {
      return window.bidConvertSuccess(receipt.transactionHash)
    }
  } catch (err) {
    if (sendBackTo == 'Buy') {
      return window.bidConvertFailed(err['message'])
    } else {
      return window.bidConvertFailed(err['message'])
    }

  }
}

window.updateBuyerServiceFee = async function updateBuyerServiceFee(buyerFeePermille) {
  try {
    var compiledContractDetails = getContractABIAndBytecode(tradeContractAddress, 'trade');
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
    var contractNFT = await new ethers.Contract( tradeContractAddress, abi, provider);
    const contract = contractNFT.connect(signer);
    var account = await getaccounts();
    var gasPrices = await gasPrice();
    var receipt = await contract.setBuyerServiceFee(buyerFeePermille, {from: account, gasPrice: String(gasPrices)});
    receipt = await receipt.wait();
    if(String(receipt.status) === "true"){
      $("form#fee_form").submit();
      $("div.loading-gif.displayInMiddle").hide()
    }

  } catch (err) {
    return false
  }
}

window.updateSellerServiceFee = async function updateSellerServiceFee(sellerFeePermille) {
  try {
    var compiledContractDetails = getContractABIAndBytecode(tradeContractAddress, 'trade');
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
    var contractNFT = await new ethers.Contract(abi, tradeContractAddress);
    const contract = contractNFT.connect(signer);
    var account = await getaccounts();
    var gasPrices = await gasPrice();
    var receipt = await contract.setSellerServiceFee(sellerFeePermille, {from: account, gasPrice: String(gasPrices)});
    receipt = await receipt.wait();
    if(String(receipt.status) === "true"){
      $("form#fee_form").submit();
      $("div.loading-gif.displayInMiddle").hide();
    }
  } catch (err) {

  }
}

window.bidAsset = async function bidAsset(assetAddress, tokenId, qty = 1, amount, payingTokenAddress, decimals = 18, collectionId, bidPayAmt) {
  try {
    var amountInDec = roundNumber(mulBy(amount, 10 ** decimals), 0);
    var nonce_value = await getNonceValue(collectionId);
    var messageHash = ethers.utils.solidityKeccak256(['address', 'uint256', 'address', 'uint256', 'uint256', 'uint256'], [assetAddress, tokenId, payingTokenAddress, amountInDec, qty, nonce_value]);
    messageHash = ethers.utils.arrayify(messageHash);
    var account = await getaccounts();
    const signature = await signer.signMessage(messageHash);
    await placeBid(collectionId, signature, qty, {
      asset_address: assetAddress,
      token_id: tokenId,
      quantity: qty,
      amount: bidPayAmt,
      amount_with_fee: amount,
      payment_token_address: payingTokenAddress,
      payment_token_decimals: decimals
    });
    await save_NonceValue(collectionId, signature, nonce_value);
    return window.bidSignSuccess(collectionId)
  } catch (err) {
    return window.bidSignFailed(err['message'])
  }
}

window.signMessage = async function signMessage(msg) {
  try {
    var sign = signer.signMessage(msg);
    return sign;
  } catch (err) {
    return ""
  }
}

window.signSellOrder = async function signSellOrder(amount, decimals, paymentAssetAddress, tokenId, assetAddress, collectionId, sendBackTo='') {
  try {
    amount = roundNumber(mulBy(amount, 10 ** decimals), 0);
    var nonce_value = await getNonceValue(collectionId);
     var messageHash = ethers.utils.solidityKeccak256(['address', 'uint256', 'address', 'uint256', 'uint256'], [assetAddress, tokenId, paymentAssetAddress, amount, nonce_value]);
     messageHash = ethers.utils.arrayify(messageHash);
    var account = getCurrentAccount()
    const fixedPriceSignature = await signer.signMessage(messageHash, account);
    await updateSignature(collectionId, fixedPriceSignature)
    await save_NonceValue(collectionId, fixedPriceSignature, nonce_value)
    if (sendBackTo == 'update') {
      return window.updateSignFixedSuccess(collectionId)
    } else {
      return window.bidSignFixedSuccess(collectionId)
    }
  } catch (err) {
    if(sendBackTo == 'update'){
      return window.updateSignFixedFailed(err['message'])
    }else{
      return window.bidSignFixedFailed(err['message'])
    }
  }
}

// buyingAssetType = 1 # 721
// buyingAssetType = 0 # 1155
window.buyAsset = async function buyAsset(assetOwner, buyingAssetType, buyingAssetAddress, tokenId, unitPrice, buyingAssetQty,
                                          paymentAmt, paymentAssetAddress, decimals, sellerSign, collectionId) {
  try {
    paymentAmt = roundNumber(mulBy(paymentAmt, 10 ** decimals), 0);
    unitPrice = roundNumber(mulBy(unitPrice, 10 ** decimals), 0);
    var compiledContractDetails = getContractABIAndBytecode(tradeContractAddress, 'trade');
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
    var contractNFT = new ethers.Contract( tradeContractAddress, abi, provider);
    const contract = contractNFT.connect(signer);    var nonce_value = await getContractSignNonce(collectionId, sellerSign);
    var account = await getaccounts();
    var orderStruct = [
      assetOwner,
      account,
      paymentAssetAddress,
      buyingAssetAddress,
      buyingAssetType,
      unitPrice,
      paymentAmt,
      tokenId,
      buyingAssetQty
    ]
    var gasPrices = await gasPrice();
    var receipt = await contract.buyAsset(
      orderStruct,
      splitSign(sellerSign, nonce_value),
      {from: account, gasLimit:516883, gasPrice: String(gasPrices)}
    );
    receipt = await receipt.wait();
    await updateCollectionBuy(collectionId, buyingAssetQty, receipt.transactionHash)
    return window.buyPurchaseSuccess(collectionId)
  } catch (err) {
    return window.buyPurchaseFailed(err['message'])
  }
}

window.executeBid = async function executeBid(buyer, buyingAssetType, buyingAssetAddress, tokenId, paymentAmt, buyingAssetQty, paymentAssetAddress, decimals, buyerSign, collectionId, bidId) {
  try {
    paymentAmt = roundNumber(mulBy(paymentAmt, 10 ** decimals), 0);
    var unitPrice = 1;
    var compiledContractDetails = getContractABIAndBytecode(tradeContractAddress, 'trade');
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
    var contractNFT = new ethers.Contract(tradeContractAddress, abi, provider);
    const contract = contractNFT.connect(signer);
    var nonce_value = await getContractSignNonce(collectionId, buyerSign);
    var account = await getaccounts();
    var orderStruct = [
      account,
      buyer,
      paymentAssetAddress,
      buyingAssetAddress,
      buyingAssetType,
      unitPrice,
      paymentAmt,
      tokenId,
      buyingAssetQty
    ]
    var gasPrices = await gasPrice();
    var receipt = await contract.executeBid(
      orderStruct,
      splitSign(buyerSign, nonce_value),
      {from: account, gasLimit:516883, gasPrice: String(gasPrices)}
    );
    receipt = await receipt.wait();
    await updateCollectionSell(collectionId, buyer, bidId, receipt.transactionHash)
    return window.acceptBidSuccess(collectionId)
  } catch (err) {
    return window.acceptBidFailed(err['message'])
  }
}

function getCurrentAccount() {
  return getaccounts();
}

window.ethBalance = async function ethBalance() {
  if (!signer) {
    await loadWeb3();
  }
  if (!signer) {
    return 0;
  }
  var account = await getaccounts();
  var bal = await signer.getBalance();
  var ethBal = roundNumber(ethers.utils.formatEther(bal), 4);
  return ethBal
}

window.updateEthBalance = async function updateEthBalance() {
  var ethBal = await window.ethBalance()
  $('.curBalance').html(ethBal + 'ETH')
  $('.curEthBalance').text(ethBal)
}

window.tokenBalance = async function tokenBalance(contractAddress, decimals) {
  var abi = [{
    "constant":true,
    "inputs":[{"name":"","type":"address"}],
    "name":"balanceOf",
    "outputs":
    [{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"}]
  var contract = new ethers.Contract( contractAddress, abi, provider);
  var account = await getaccounts();
  var balance = await contract.balanceOf(account);
  var bal = parseInt(balance);
  balance = roundNumber(divBy(bal, (10 ** decimals)), 4)
  return balance
}

window.getNetworkType = async function getNetworkType() {
  var type = await provider.getNetwork();
  return type["name"];
}

function showTermsCondition(account, ethBal, networkType) {
  var account = account || window.ethereum.selectedAddress
  $.magnificPopup.open({
    closeOnBgClick: false ,
		enableEscapeKey: false,
    items: {
      src: '#terms-and-condition'
    },
    type: 'inline'
  });
  $("#account").val(account)
  $("#eth_balance_tc").val(ethBal)
  $("#network_type").val(networkType)
}

async function load(shoulDestroySession = false) {
  if (window.ethereum) {
    await loadWeb3();
    var account = await getaccounts();
    var networkType = await getNetworkType();
    var ethBal = await ethBalance();
    const isValidUserResp = await isValidUser(account, '')
    if (isValidUserResp.user_exists) {
      await createUserSession(account, ethBal, shoulDestroySession)
      if (shoulDestroySession) {
        window.location.href = '/'
      } else {
        return true
      }
    } else {
      if (gon.session) {
        if (account) {
          await destroySession()
        }
        window.location.href = '/'
      } else {
        showTermsCondition(account, ethBal, networkType)
        return false
      }
    }
  }
}

window.disconnect = async function disconnect(address) {
  await destroySession()
  window.location.href = '/'
}

async function destroySession() {
  if (gon.session) {
    await destroyUserSession(account)
  }
}

window.connect = async function connect(address) {
  if (!window.ethereum && mobileCheck()) {
    window.open(`https://metamask.app.link/dapp/` + location.hostname, '_blank').focus();
    return
  } else if (window.ethereum) {
    const status = await load();
    if (status) {
      window.location.href = '/'
    }
  } else {
    toastr.error('Please install Metamask Extension to your browser.')
  }
}

window.proceedWithLoad = async function proceedWithLoad() {
  var account = $("#account").val()
  const ethBal = $("#eth_balance").text()
  const networkType = $("#network_type").val()
  if ($("#condition1").is(":checked") && $("#condition2").is(":checked")) {
    await createUserSession(account, ethBal, networkType)
    window.location.href = '/'
  } else {
    toastr.error('Please accept the conditions to proceed')
  }
}

window.loadUser = async function loadUser() {
  if (window.ethereum && gon.session) {
    load();
  }
}

function gasPrice(){
var init_gasPrice = '400000000000';
  if ( gon.tokenSymbol == "WBNB"){
    init_gasPrice= '100000000000';
  }
  if(gon.tokenSymbol == "WETH" || gon.tokenSymbol == "WMATIC"){
    try {
      var request = $.ajax({
        url: `/gas_price`,
        async: false,
        type: "GET"
      });
      request.done(function (msg) {
        if (msg['gas_price'] != '')
        {
          init_gasPrice = msg['gas_price']['fastest'] * 10**8;
        }
      });
      request.fail(function (jqXHR, textStatus) {
       });
    } catch (err) {
    }
  }
  return toNum(init_gasPrice);
}
async function loadAddress() {
  await loadWeb3();
}

$(function () {
  loadAddress();
});
if (window.ethereum){
  window.ethereum.on('accountsChanged', function (acc) {
    if (window.ethereum && gon.session) {
      load(true);
    }
  })
  window.ethereum.on('chainChanged', function (chainId) {
    window.syncSiteNetworkFromMetaMask(chainId);
  })
}
window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
